module.exports = __webpack_public_path__ + "static/img/9_1.9080edb9.jpg";